// 상담톡 상태 상수
export const COUNSELOR_STATUS = {
  PENDING: 'pending',
  CONNECTED: 'connected',
  DISCONNECTING: 'disconnecting',
  DISCONNECTED: 'disconnected',
};

// 상태별 라벨
export const COUNSELOR_STATUS_LABEL = {
  [COUNSELOR_STATUS.PENDING]: '승인대기',
  [COUNSELOR_STATUS.CONNECTED]: '연결됨',
  [COUNSELOR_STATUS.DISCONNECTING]: '해지대기',
  [COUNSELOR_STATUS.DISCONNECTED]: '해지됨',
};

// 상태별 태그 색상
export const COUNSELOR_STATUS_COLOR = {
  [COUNSELOR_STATUS.PENDING]: 'orange',
  [COUNSELOR_STATUS.CONNECTED]: 'green',
  [COUNSELOR_STATUS.DISCONNECTING]: 'gold',
  [COUNSELOR_STATUS.DISCONNECTED]: 'default',
};

// 상태 옵션 (셀렉트박스용)
export const COUNSELOR_STATUS_OPTIONS = [
  { value: COUNSELOR_STATUS.PENDING, label: COUNSELOR_STATUS_LABEL[COUNSELOR_STATUS.PENDING] },
  { value: COUNSELOR_STATUS.CONNECTED, label: COUNSELOR_STATUS_LABEL[COUNSELOR_STATUS.CONNECTED] },
  { value: COUNSELOR_STATUS.DISCONNECTING, label: COUNSELOR_STATUS_LABEL[COUNSELOR_STATUS.DISCONNECTING] },
  { value: COUNSELOR_STATUS.DISCONNECTED, label: COUNSELOR_STATUS_LABEL[COUNSELOR_STATUS.DISCONNECTED] },
];

// 필터용 상태 옵션 (전체 포함)
export const COUNSELOR_STATUS_FILTER_OPTIONS = [
  { value: '', label: '전체' },
  ...COUNSELOR_STATUS_OPTIONS,
];
